if (!customElements.get('selected-option-value')) {
  class SelectedOptionValue extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      subscribe(PUB_SUB_EVENTS.variantChange, this.updateValue.bind(this));
    }

    updateValue(e) {
      // console.log(e);
      let option_id = this.dataset.option;
      this.textContent = e.data.variant[option_id];

      // leadtime update
      let $leadtime = document.querySelector('[data-leadtime]');
      if ($leadtime) {
        $leadtime.textContent = e.data.variant.available ? $leadtime.dataset.leadtime : $leadtime.dataset.soldout;
      }
    }
  }

  customElements.define('selected-option-value', SelectedOptionValue);
}

if (!customElements.get('custom-accordion')) {
  class CustomAccordion extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.$button = this.querySelector('.accordion-button');
      this.$panel = this.querySelector('.accordion-panel');
      this.$button.addEventListener('click', this.ToggleAccordion.bind(this));
      this.keep_state = this.dataset.keep_state === 'true';
      this.accordion_id = this.dataset.id || null;

      // Set initial height if panel is open
      if (this.$panel.classList.contains("panel-open")) {
        this.$panel.style.height = this.$panel.scrollHeight + "px";
      }
    }

    ToggleAccordion() {
      const title = this.$button
      const panel = this.$panel;
      const isExpanded = title.getAttribute('aria-expanded') === 'true';

      if (isExpanded) {
        // Close the panel
        panel.style.height = null;
        panel.classList.remove("panel-open");
        panel.setAttribute("aria-hidden", "true");
        title.classList.remove("active");
        title.setAttribute("aria-expanded", "false");
      } 
      else {
        // Open the panel
        panel.style.height = panel.scrollHeight + "px";
        panel.classList.add("panel-open");
        panel.setAttribute("aria-hidden", "false");
        title.classList.add("active");
        title.setAttribute("aria-expanded", "true");
      }
    }
  }
  customElements.define('accordion-custom', CustomAccordion);
}

document.addEventListener('alpine:init', () => {
  console.log('Alpine.js initialized');

  const fabricsSessionKey = 'fabric_products';
  Alpine.data('FabricOptions', () => ({
    flags: {
      show_fabric_tooltip: false,
    },
    init() {
      this.$self = this.$el;
      this.LoadFabricProducts();
    },

    async e_LoadToolTip(e) {
      let $tooltip = this.$self.querySelector('.fabric-tooltip-wrap');
      let fabric_handle = e.target.dataset.fabric_handle;
      let fabrics = JSON.parse(sessionStorage.getItem(fabricsSessionKey));
      let fabric = fabrics.find(fabric => fabric.handle === fabric_handle);
      // console.log('fabric found:', fabric);
      if (!fabric) return;

      // populate tooltip content
      $tooltip.querySelector('.fabric-title').textContent = fabric.title;
      // load image to ensure it's loaded before showing tooltip
      let image = new Image();
      image.src = `${ fabric.images[0] }&width=800`;
      await image.decode();
      $tooltip.querySelector('.fabric-image img').src = `${ fabric.images[0] }&width=800`;
      $tooltip.querySelector('.fabric-description').innerHTML = fabric.description || '';
      $tooltip.querySelector('.fabric-link a').href = `/products/${ fabric.handle }`;

      this.flags.show_fabric_tooltip = true;
    },

    async LoadFabricProducts() {
      let fabrics = JSON.parse(sessionStorage.getItem(fabricsSessionKey)) || [];
      // console.log('cached fabrics:', fabrics);
      
      let fabric_handles = [...this.$el.querySelectorAll('[data-fabric_handle]')].map(el => el.dataset.fabric_handle);
      // remove items already in cached fabrics
      fabric_handles = fabric_handles.filter(handle => !fabrics.find(fabric => fabric.handle === handle));

      let fabrics_px = fabric_handles.map(async handle => {
        let response = await fetch(`/products/${handle}.js`);
        if (response.ok) {
          return await response.json();
        } 
        else {
          console.error(`Failed to fetch product data for handle: ${handle}`);
          return null;
        }
      });
      fabrics = [...fabrics, ...await Promise.all(fabrics_px)];
      fabrics = fabrics.filter(fabric => !!fabric);
      // console.log('fabrics:', fabrics);
      // cache fabrics data to session storage
      sessionStorage.setItem(fabricsSessionKey, JSON.stringify(fabrics));
    }
  }));

  Alpine.data('CustomDrawerToggle', () => ({
    e_OpenDrawer(drawer_id) {
      const drawer = document.getElementById(drawer_id);
      if (!drawer) return;
      drawer.dispatchEvent(new CustomEvent('open-drawer', { bubbles: true }) );
    }
  }));

  Alpine.data('CustomDrawer', () => ({
    flags: {
      open: false
    },
    init() {
      // move trigger to before element
      const trigger = this.$el.querySelector('[x-data="CustomDrawerToggle"]');
      if (trigger) {
        this.$el.insertAdjacentElement('beforebegin', trigger);
      }

      // move drawer to body
      document.body.appendChild(this.$el);
      
      this.InitWatchers();
    },
    InitWatchers() {
      this.$el.querySelector('.cc-modal').addEventListener('open-drawer', () => {
        this.flags.open = true;
      });
    }
  }));

  Alpine.data('RequestQuoteForm', () => ({
    async e_SubmitContactForm() {
      const form = this.$el.closest('form');
      if (!form) return;

      // if form has element of product-url, update url value
      const productUrlInput = form.querySelector('#product-url');
      if (productUrlInput) {
        productUrlInput.value = window.location.href;
      }

      form.submit();
    }
  }));

  Alpine.data('ContactFormSubmitted', () => ({
    flags: {
      show: false,
    },
    init() {
      // if url has parameter contact_posted=true, show the message
      const urlParams = new URLSearchParams(window.location.search);
      if (urlParams.get('contact_posted') === 'true') {
        this.flags.show = true;
      }

      // remove the parameter from the URL without reloading the page
      if (this.flags.show) {
        const url = new URL(window.location);
        url.searchParams.delete('contact_posted');
        window.history.replaceState({}, document.title, url.toString());

        // also remove this from url #contact_form
        if (url.hash === '#contact_form') {
          url.hash = '';
          window.history.replaceState({}, document.title, url.toString());
        }

        // hide the message after 3 seconds
        setTimeout(() => {
          this.flags.show = false;
        }, 5000);
      }
    }
  }));
});